class ThumbnailStorage {
  private storage: Map<string, string> = new Map();

  set(videoGuid: string, thumbnailUrl: string): void {
    this.storage.set(videoGuid, thumbnailUrl);
    console.log(`✅ [ThumbnailStorage.set] Stored thumbnail URL for videoGuid: ${videoGuid}`, {
      thumbnailUrl: thumbnailUrl.substring(0, 80) + '...',
      totalStoredThumbnails: this.storage.size
    });
  }

  get(videoGuid: string): string | undefined {
    const thumbnailUrl = this.storage.get(videoGuid);
    console.log(`🔍 [ThumbnailStorage.get] Retrieving thumbnail URL for videoGuid: ${videoGuid}`, {
      found: !!thumbnailUrl,
      thumbnailUrl: thumbnailUrl ? thumbnailUrl.substring(0, 80) + '...' : 'NOT FOUND',
      totalStoredThumbnails: this.storage.size,
      allStoredGuids: Array.from(this.storage.keys())
    });
    return thumbnailUrl;
  }

  delete(videoGuid: string): boolean {
    const existed = this.storage.has(videoGuid);
    this.storage.delete(videoGuid);
    console.log(`🗑️ [ThumbnailStorage.delete] Deleted thumbnail URL for videoGuid: ${videoGuid}`, {
      existed,
      remainingThumbnails: this.storage.size
    });
    return existed;
  }

  clear(): void {
    const count = this.storage.size;
    this.storage.clear();
    console.log(`🧹 [ThumbnailStorage.clear] Cleared all thumbnail URLs`, { count });
  }
}

export const thumbnailStorage = new ThumbnailStorage();
